<verify-email-page>
  <div if="{locale}" class="container">
    <div class="verification-card">
      <div class="brand-header">
        <img src="./Lark.png" alt="MetaLark.ai" class="brand-logo" />
        <h1 class="brand-title text-accent font-bold">{locale?.t('verifyemail_welcome')}</h1>
        <p class="brand-tagline font-medium">{locale?.t('verifyemail_tagline')}</p>
      </div>

      <div if="{state.loading}" class="loading-state">
        <div class="spinner"></div>
        <h2 class="text-accent font-medium">{locale?.t('verifyemail_verifying_title')}</h2>
        <p>{locale?.t('verifyemail_verifying_message')}</p>
      </div>

        <div if={state.success && !state.showPasswordForm && !state.passwordSetSuccess} class="success-state">
            <div class="success-icon">✓</div>
            <h2 class="text-accent font-medium">{locale?.t('verifyemail_success_title')}</h2>
            <p class="font-medium">{state.message}</p>
            <p class="next-step font-medium">{locale?.t('verifyemail_nextstep')}</p>
            <button onclick={showPasswordForm} class="btn btn-primary">
              {locale?.t('verifyemail_continue')}
            </button>
          </div>

        <div if={state.showPasswordForm && !state.passwordSetSuccess} class="password-form-state">
        <h2 class="text-accent font-medium">{locale?.t('verifyemail_setpassword_title')}</h2>
        <p class="form-description font-medium">{locale?.t('verifyemail_setpassword_description')}</p>
        
        <form onsubmit={handlePasswordSubmit} autocomplete="on">
          <input
            type="email"
            name="username"
            autocomplete="username"
            value={state.userEmail}
            style="display: none;"
            tabindex="-1"
            aria-hidden="true"
          />
          <div class="password-field-container">
            <div class="form-group password-input-column">
              <label for="new-password">{locale?.t('verifyemail_password')}</label>
              <div class="password-input-wrapper">
                <input
                  type={state.showPassword ? 'text' : 'password'}
                  id="new-password"
                  name="new-password"
                  autocomplete="new-password"
                  value={state.password}
                  oninput={handlePasswordInput}
                  required
                  minlength="12"
                  placeholder="{locale?.t('verifyemail_passwordplaceholder')}"
                />
                <button
                  type="button"
                  class="password-toggle"
                  onclick={togglePasswordVisibility}
                  aria-label={state.showPassword ? locale?.t('verifyemail_hidepassword') : locale?.t('verifyemail_showpassword')}
                >
                  <i class="{state.showPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
                </button>
              </div>
            </div>
            
            <div class="password-requirements">
              <div class="text-primary font-medium mb-1">{locale?.t('verifyemail_requirements')}</div>
              <ul class="requirements-list">
                <li class="{state.password.length >= 12 ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('verifyemail_req_length')} <span class="char-count">({state.password.length}/12)</span>
                </li>
                <li class="{/[A-Z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('verifyemail_req_uppercase')}
                </li>
                <li class="{/[a-z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('verifyemail_req_lowercase')}
                </li>
                <li class="{/[0-9]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('verifyemail_req_number')}
                </li>
                <li class="{/[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('verifyemail_req_special')}
                </li>
              </ul>
            </div>
          </div>

          <div class="form-group">
            <label for="confirm-password">{locale?.t('verifyemail_confirmpassword')}</label>
            <div class="password-input-wrapper">
              <input
                type={state.showConfirmPassword ? 'text' : 'password'}
                id="confirm-password"
                name="confirm-password"
                autocomplete="new-password"
                value={state.confirmPassword}
                oninput={handleConfirmPasswordInput}
                required
                minlength="8"
                placeholder="{locale?.t('verifyemail_confirmpasswordplaceholder')}"
              />
              <button
                type="button"
                class="password-toggle"
                onclick={toggleConfirmPasswordVisibility}
                aria-label={state.showConfirmPassword ? locale?.t('verifyemail_hidepassword') : locale?.t('verifyemail_showpassword')}
              >
                <i class="{state.showConfirmPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
              </button>
            </div>
          </div>

          <div if={state.passwordError} class="error-alert">{state.passwordError}</div>

          <button
            type="submit"
            class="btn btn-primary"
            disabled={state.settingPassword}
          >
            {state.settingPassword ? locale?.t('verifyemail_settingpassword') : locale?.t('verifyemail_setpasswordbutton')}
          </button>
        </form>
      </div>

      <div if={state.error && !state.showResendForm} class="error-state">
        <div class="error-icon">✗</div>
        <h2>{locale?.t('verifyemail_failed_title')}</h2>
        <p class="error-message">{state.message}</p>
        <div class="error-actions">
          <button onclick={showResendForm} class="btn btn-primary border-0 font-bold text-md">
            {locale?.t('verifyemail_requestnewlink')}
          </button>
          <a href="#/login" class="btn btn-secondary font-bold text-md">{locale?.t('verifyemail_returntologin')}</a>
        </div>
      </div>

      <div if={state.showResendForm} class="resend-form-state">
        <h2>{locale?.t('verifyemail_requestlink_title')}</h2>
        <p class="form-description font-medium">{locale?.t('verifyemail_requestlink_description')}</p>

        <form onsubmit={handleResendSubmit}>
          <div class="form-group">
            <label for="resend-email" class="font-medium text-lg font-accent">{locale?.t('verifyemail_emailaddress')}</label>
            <input
              type="email"
              id="resend-email"
              name="email"
              autocomplete="email"
              value={state.resendEmail}
              oninput={handleResendEmailInput}
              required
              placeholder="{locale?.t('verifyemail_emailplaceholder')}"
            />
          </div>

          <div if={state.resendError} class="error-alert">{state.resendError}</div>
          <div if={state.resendSuccess} class="success-alert">{state.resendSuccess}</div>

          <div class="form-actions">
            <button
              type="submit"
              class="btn btn-primary"
              disabled={state.sendingResend}
            >
              {state.sendingResend ? locale?.t('verifyemail_sending') : locale?.t('verifyemail_sendlink')}
            </button>
            <button
              type="button"
              onclick={cancelResend}
              class="btn btn-text"
            >
              {locale?.t('verifyemail_cancel')}
            </button>
          </div>
        </form>
      </div>

      <div if={state.passwordSetSuccess} class="success-state">
        <div class="success-icon">✓</div>
        <h2>{locale?.t('verifyemail_passwordsetsuccess_title')}</h2>
        <p class="font-medium">{locale?.t('verifyemail_passwordsetsuccess_message')}</p>
        <p class="next-step">{locale?.t('verifyemail_passwordsetsuccess_nextstep')}</p>
        <a href="#/login" class="btn btn-primary">
          {locale?.t('verifyemail_gotologin')}
        </a>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      padding: 20px;
      border-radius: 20px;
    }

    .verification-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 500px;
      width: 100%;
      text-align: center;
    }

    /* Wider card on larger screens to accommodate two-column layout */
    @media (min-width: 768px) {
      .verification-card {
        max-width: 750px;
      }
    }

    .brand-header {
      /*margin-bottom: 32px;*/
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e7eb;
    }

    .brand-logo {
      height: 48px;
      width: auto;
      margin: 0 auto 16px;
      display: block;
    }

    .brand-title {
      /*color: #1f2937;*/
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 8px;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      /*-webkit-background-clip: text;*/
      /*-webkit-text-fill-color: transparent;*/
      /*background-clip: text;*/
    }

    /*.brand-tagline {*/
    /*  color: #6b7280;*/
    /*  font-size: 14px;*/
    /*  font-weight: 500;*/
    /*  margin: 0;*/
    /*  letter-spacing: 0.5px;*/
    /*}*/

    .loading-state,
    .success-state,
    .error-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid var(--color-primary);
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .success-icon,
    .error-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    .success-icon {
      color: #10b981;
    }

    .error-icon {
      color: #ef4444;
    }

    h2 {
      color: var(--color-accent);
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .next-step {
      color: #4b5563;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 24px;
    }

    .error-message {
      color: #dc2626;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .password-form-state {
      animation: fadeIn 0.3s ease-in;
    }

    .form-description {
      color: #6b7280;
      margin-bottom: 24px;
    }

    .form-group {
      margin-bottom: 20px;
      text-align: left;
    }

    label {
      display: block;
      color: #374151;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .password-input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .password-input-wrapper input {
      width: 100%;
      padding: 12px 48px 12px 16px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.2s;
      box-sizing: border-box;
    }

    .password-input-wrapper input:focus {
      outline: none;
      border-color: #667eea;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    .password-toggle {
      position: absolute;
      right: 12px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      opacity: 0.6;
      transition: opacity 0.2s;
    }

    .password-toggle:hover {
      opacity: 1;
    }

    .password-toggle:focus {
      outline: 2px solid #667eea;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .form-hint {
      display: block;
      color: #6b7280;
      font-size: 13px;
      margin-top: 4px;
    }

    .password-field-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 20px;
    }

    .password-input-column {
      flex: 1;
      margin-bottom: 0;
    }

    .password-requirements {
      padding: 12px;
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      flex-shrink: 0;
      text-align: left;
    }

    .requirements-title {
      font-size: 12px;
      color: #1e40af;
      font-weight: 600;
      margin-bottom: 4px;
    }

    .requirements-list {
      list-style: disc;
      margin-left: 16px;
      padding-left: 4px;
      font-size: 12px;
      line-height: 1.6;
    }

    .requirements-list li {
      margin-bottom: 2px;
    }

    .requirement-pending {
      color: var( --color-base-content);
    }

    .requirement-met {
      color: #15803d;
      font-weight: 600;
    }

    .char-count {
      font-family: monospace;
    }

    /* Two-column layout on larger screens */
    @media (min-width: 768px) {
      .password-field-container {
        flex-direction: row;
        align-items: flex-start;
        gap: 16px;
      }

      .password-input-column {
        flex: 1;
        max-width: 400px;
      }

      .password-requirements {
        width: 280px;
        margin-top: 32px; /* Align with input field after label */
      }
    }

    .error-alert {
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .success-alert {
      background: #d1fae5;
      border: 1px solid #a7f3d0;
      color: #065f46;
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .resend-form-state {
      animation: fadeIn 0.3s ease-in;
    }

    .form-actions {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    /*.btn {*/
    /*  padding: 2px 24px;*/
    /*  border-radius: 8px;*/
    /*  font-weight: 500;*/
    /*  cursor: pointer;*/
    /*  transition: all 0.2s;*/
    /*  border: none;*/
    /*  font-size: 16px;*/
    /*  text-decoration: none;*/
    /*  display: inline-block;*/
    /*}*/

    .btn-block {
      width: 100%;
      display: block;
    }

    .btn-primary {
      background: var(--color-primary);
      color: white;
    }

    .btn-primary:hover:not(:disabled) {
      background: var(--color-primary);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:disabled {
      background: #9ca3af;
      cursor: not-allowed;
    }

    .btn-secondary {
      background: #ffffff;
      color: var(--color-primary);
      border: 1px solid var(--color-primary);
      margin-right: 12px;
        box-shadow: none;
    }

    .btn-secondary:hover {
        background: #ffffff;
        color: var(--color-primary);
        border: 1px solid var(--color-primary);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .error-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .error-actions {
        flex-direction: row;
        justify-content: center;
      }
    }


    input[type="email"] {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        font-size: 16px;
        transition: border-color 0.2s;
        box-sizing: border-box;
    }

    input[type="email"]:focus {
        outline: none;
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      includeTools: false,

      state: {
        loading: true,
        success: false,
        error: false,
        message: '',
        userUuid: null,
        userEmail: '',
        showPasswordForm: false,
        passwordSetSuccess: false,
        password: '',
        confirmPassword: '',
        passwordError: '',
        settingPassword: false,
        verificationToken: '',
        showResendForm: false,
        resendEmail: '',
        resendError: '',
        resendSuccess: '',
        sendingResend: false,
        showPassword: false,
        showConfirmPassword: false
      },

      async onMounted() {
        // Get token from query params
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        const token = urlParams.get('token')

        if (!token) {
          this.update({
            loading: false,
            error: true,
            message: this.locale.t('verifyemail_error_notoken')
          })
          return
        }

        // Verify the token
        await this.verifyEmail(token)
      },

      async verifyEmail(token) {
        try {
          const api = await getApi()
          const response = await api.post('/email/verify', { token })

          if (response.data.success) {
            this.update({
              loading: false,
              success: true,
              error: false,
              message: response.data.message,
              userUuid: response.data.userUuid,
              userEmail: response.data.email || '',
              verificationToken: token
            })
          } else {
            this.update({
              loading: false,
              success: false,
              error: true,
              message: response.data.message || this.locale.t('verifyemail_error_verification')
            })
          }
        } catch (error) {
          console.error('Email verification error:', error)
          this.update({
            loading: false,
            success: false,
            error: true,
            message: error.response?.data?.message || error.message || this.locale.t('verifyemail_error_generic')
          })
        }
      },

      showPasswordForm() {
        this.update({ showPasswordForm: true })
      },

      handlePasswordInput(e) {
        this.update({ password: e.target.value, passwordError: '' })
      },

      handleConfirmPasswordInput(e) {
        this.update({ confirmPassword: e.target.value, passwordError: '' })
      },

      async handlePasswordSubmit(e) {
        e.preventDefault()

        const { password, confirmPassword, verificationToken } = this.state

        // Validate passwords match
        if (password !== confirmPassword) {
          this.update({ passwordError: this.locale.t('verifyemail_error_passwordmismatch') })
          return
        }

        // Validate password strength
        if (!this.validatePasswordStrength(password)) {
          this.update({ passwordError: this.locale.t('verifyemail_error_passwordcriteria') })
          return
        }

        this.update({ settingPassword: true, passwordError: '' })

        try {
          const api = await getApi()
          const response = await api.post('/auth/password/setup/complete', {
            setupToken: verificationToken,
            newPassword: password,
            confirmPassword
          })

          if (response.data.success) {
            // Success! Show inline success message
            this.update({
              passwordSetSuccess: true,
              settingPassword: false,
              showPasswordForm: false
            })
          } else {
            this.update({
              settingPassword: false,
              passwordError: response.data.message || this.locale.t('verifyemail_error_setpassword')
            })
          }
        } catch (error) {
          console.error('Password setup error:', error)
          this.update({
            settingPassword: false,
            passwordError: error.response?.data?.message || this.locale.t('verifyemail_error_setpasswordretry')
          })
        }
      },

      showResendForm() {
        this.update({
          showResendForm: true,
          error: false,
          resendError: '',
          resendSuccess: ''
        })
      },

      cancelResend() {
        this.update({
          showResendForm: false,
          error: true,
          resendEmail: '',
          resendError: '',
          resendSuccess: ''
        })
      },

      handleResendEmailInput(e) {
        this.update({ resendEmail: e.target.value, resendError: '', resendSuccess: '' })
      },

      async handleResendSubmit(e) {
        e.preventDefault()

        const { resendEmail } = this.state

        if (!resendEmail) {
          this.update({ resendError: this.locale.t('verifyemail_error_emailrequired') })
          return
        }

        this.update({ sendingResend: true, resendError: '', resendSuccess: '' })

        try {
          const api = await getApi()
          const response = await api.post('/email/resend-verification', {
            email: resendEmail
          })

          if (response.data.success) {
            this.update({
              sendingResend: false,
              resendSuccess: response.data.message || this.locale.t('verifyemail_resendsuccess'),
              resendError: ''
            })
          } else {
            this.update({
              sendingResend: false,
              resendError: response.data.message || this.locale.t('verifyemail_error_resendfailed')
            })
          }
        } catch (error) {
          console.error('Resend verification error:', error)
          this.update({
            sendingResend: false,
            resendError: error.response?.data?.message || this.locale.t('verifyemail_error_resendretry')
          })
        }
      },

      togglePasswordVisibility() {
        this.update({ showPassword: !this.state.showPassword })
      },

      toggleConfirmPasswordVisibility() {
        this.update({ showConfirmPassword: !this.state.showConfirmPassword })
      },

      validatePasswordStrength(password) {
        if (!password || password.length < 12) {
          return false
        }
        
        // Check for required character types
        const hasUppercase = /[A-Z]/.test(password)
        const hasLowercase = /[a-z]/.test(password)
        const hasNumber = /[0-9]/.test(password)
        const hasSpecialChar = /[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(password)
        
        return hasUppercase && hasLowercase && hasNumber && hasSpecialChar
      }
    }
  </script>
</verify-email-page>